export default "__VITE_ASSET__C0_Vz7UO__"